import React from 'react'
import { checkPermission, checkTranslation, translate } from '../utils/useful'
import TableRow from './partials/TableRow';
import TableHead from './partials/TableHead';
import DraggableList from './dragLibrary/DraggableList';
import { getBoundingClientRect } from '../utils/functions';
import { detectBrowser } from '../utils/useful'
import Loader from 'react-loader-spinner'
import Modal from './Modal';
import { isTableActionVisible } from '../utils/workflowDocumentActions'

class TableViewer extends React.Component {
    state = {
        errors: {},
        data: {},
        width: window.innerWidth,
        selectedRowData: null,
    }
    headerIsScrolling = false
    scrollTrigger = null

    componentDidMount() {
        this.init()
        window.addEventListener('resize', this.setWidth);

        this.setState({ broswer: detectBrowser() })
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.setWidth)
    }

    componentDidUpdate(prevProps) {
        if ((this.props.data != prevProps.data) || (this.props.headers !== prevProps.headers)) {
            this.init()
        }
    }




    init = () => {
        if (Array.isArray(this.props.headers)) {
            let cellWidths = this.calcCellWidths()
            let headers = this.prepareHeader()
            this.setState({ data: this.props.data, cellWidths, show: true, headers }, () => {
                this.setWidth()
            })
        }
    }


    prepareHeader() {
        return this.props.headers
    }


    calcCellWidths() {
        let cellWidths = {}
        cellWidths['*'] = 0
        let baseWidth = 120
        let actionsWidth = 120

        let numberOfHeader = 0

        this.props.headers.forEach(header => {
            if (header.showMain == true) {
                numberOfHeader++
            }
        });

        if (this.tableContainer) {
            let tableWidth = getBoundingClientRect(this.tableContainer).width
            tableWidth = tableWidth - actionsWidth
            if (this.props.headers?.length * baseWidth < tableWidth) {
                baseWidth = (tableWidth - actionsWidth) / numberOfHeader
            }

        }

        this.props.headers.forEach(header => {
            if (header.showMain != false) {
                cellWidths[header.key] = baseWidth // TODO: CHANGE BY TYPE
                cellWidths['*'] += baseWidth
            }
        });
        cellWidths['*actions'] = actionsWidth // TODO: CHANGE BY TYPE
        cellWidths['*'] = cellWidths['*'] + actionsWidth + 30 // TODO: CHANGE BY TYPE


        // cellWidths['*'] = cellWidths['*'] + 150

        return cellWidths

    }




    setWidth = () => {
        if (this.tableContainer) {
            this.setState({ width: this.tableContainer.getBoundingClientRect().width }, () => {
                this.changeWidth()
            })
        }
    }




    tableColBuilder(col) {
        let finalCol = 'col-12'

        if (600 < this.state.width && col) {
            finalCol = 'col-' + col
        }

        return finalCol
    }




    updateData = (data, cb) => {
        this.setState({ data }, () => {
            if (cb) {
                cb()
            }
            if (this.props.updateData) {
                this.props.updateData(data)
            }
        })
    }


    changeWidth = (key, width) => {
        let cellWidths = this.state.cellWidths
        cellWidths[key] = width

        cellWidths['*'] = 30
        for (const [key, value] of Object.entries(cellWidths)) {
            if (value) {
                cellWidths['*'] += value
            }
        }

        if (cellWidths['*'] < this.state.width) {
            cellWidths['*'] = this.state.width
        }
        this.setState({ cellWidths })
    }


    tableScroll = (e, ref) => {

        let scrollLeft = e.target.scrollLeft
        this.syncronizer('table', scrollLeft, e.timeStamp)
    }

    headerScroll = (e) => {
        let scrollLeft = e.target.scrollLeft
        this.syncronizer('header', scrollLeft, e.timeStamp)
    }



    scrollMouseDown = (e) => {
        console.log('tp1')
        this.initWidth = getBoundingClientRect(this.scrollIndicator).width
        this.initLeft = getBoundingClientRect(this.scrollIndicator).left
        this.tableInitLeft = getBoundingClientRect(this.table).left

        this.initX = e.clientX
        document.body.classList.add("no-user-select")

        window.addEventListener("mousemove", this.scollMouseMove)
        window.addEventListener("mouseup", this.scollMouseUp)

    }

    scollMouseMove = (e) => {

        console.log('tp2')
        let x = e.clientX
        let dx = 0
        if (document.body.classList.contains('rtl')) {

            dx = -x + this.initX
        } else {
            dx = x - this.initX

        }
        let scrollIndicator = (this.initLeft - this.tableInitLeft) + dx//scrollX * 100

        if ((scrollIndicator + this.initWidth) > this.state.width) {
            scrollIndicator = this.state.width - this.initWidth
        }

        if (scrollIndicator <= 0) {
            scrollIndicator = 0//this.state.width - this.initWidth
        }
        let isRtl = false
        let scrollChange = (this.state.cellWidths['*'] / this.state.width) * scrollIndicator
        if (document.body.classList.contains('rtl')) {
            scrollChange = (this.state.cellWidths['*'] / this.state.width) * scrollIndicator * -1
            isRtl = true
        }
        this.syncronizer('indicator', scrollChange, null, isRtl)
    }



    lastTrigger = null
    lastTriggerTime = null

    syncronizer(trigger, scrollLeft, timeStamp, isRtl) {
        if (!this.lastTrigger) {
            this.lastTrigger = trigger
            this.lastTriggerTime = timeStamp
        } else {
            if (this.lastTrigger != trigger) {

                if (timeStamp && timeStamp > this.lastTriggerTime + 100) {
                    this.lastTrigger = trigger
                    this.lastTriggerTime = timeStamp
                } else {
                    if (!timeStamp) {
                        this.lastTrigger = trigger
                    }
                }

            } else {
                this.lastTriggerTime = timeStamp
            }
        }

        if (this.lastTrigger != 'header') {
            this.header.scrollTo(scrollLeft, 0)
        }

        if (this.lastTrigger != 'table') {
            this.table.scrollTo(scrollLeft, 0)
        }
        this.scrollTheIndicator(trigger, scrollLeft, isRtl)
    }



    scrollTheIndicator = (trigger, scrollLeft, isRtl) => {


        let scrollIndicator = scrollLeft / this.state.cellWidths['*'] * 100
        let isRTL = false
        if (document.body.classList.contains('rtl')) {
            isRTL = true
        }

        if (this.scrollIndicator) {
            this.scrollIndicator.style.transition = 'none'
            if (!isRTL) {
                this.scrollIndicator.style.marginLeft = scrollIndicator + '%'
                this.scrollIndicator.style.marginRight = 'auto'

            }
            else {
                this.scrollIndicator.style.marginRight = (-1 * scrollIndicator) + '%'
                this.scrollIndicator.style.marginLeft = 'auto'
            }
            // if (isRtl) {
            //     this.scrollIndicator.style.marginLeft = scrollIndicator + '%'
            //     this.scrollIndicator.style.marginRight = 'auto'
            // }
        }
    }


    scollMouseUp = (e) => {
        document.body.classList.remove("no-user-select")
        this.lastTrigger = null

        window.removeEventListener("mousemove", this.scollMouseMove)
        window.removeEventListener("mouseup", this.scollMouseUp)
    }


    openActionsModal = (rowData, index) => {
        this.selectedRowData = rowData
        this.selectedRowIndex = index
        this.setState({ selectedRowData: rowData }, () => {
            this.actionsModal.showModal()
        })
    }


    openRow = (rowData, index) => {
        this.selectedRowData = rowData
        this.selectedRowIndex = index
        if (this.props.actions?.edit) {

            if (typeof this.props.actions.edit.function == 'function') {
                this.props.actions.edit.function(this.selectedRowData, this.selectedRowIndex)
            } else {
                if (this.props[this.props.actions.edit.function]) {
                    this.props[this.props.actions.edit.function](this.selectedRowData, this.selectedRowIndex, this.props.actions.edit)
                } else {
                    if (this.props.functionsHandler) {
                        this.props.functionsHandler(this.selectedRowData, this.selectedRowIndex, this.props.actions.edit)
                    }
                }
            }
        }
    }




    actionClicked = (prop, index) => {
        if (typeof prop.function == 'function') {
            prop.function(this.selectedRowData, this.selectedRowIndex)
        } else {
            if (this.props[prop.function]) {
                this.props[prop.function](this.selectedRowData, this.selectedRowIndex, prop)

            } else {
                if (this.props.functionsHandler) {
                    this.props.functionsHandler(this.selectedRowData, this.selectedRowIndex, prop)
                }
            }
        }

        this.actionsModal.hideModal()
    }

    render() {
        if (this.state.show) {
            let RowContainerComponent = "div"
            if (this.props.settings?.isSortable) {
                RowContainerComponent = DraggableList
            }

            return (
                <section ref={el => this.tableContainer = el} className={"w-100 table defaultTable  mb-3 " + (this.state.broswer)}  >
                    <div onScrollCapture={(e) => this.headerScroll(e)} ref={el => this.header = el} className="text-center w-100 no-scrollbar" style={{ overflow: 'auto', zIndex: 9, position: 'sticky', top: this.props.top ?? 47, backgroundColor: '#fff' }}>
                        <TableHead headers={this.props.headers} widths={this.state.cellWidths} changeWidth={this.changeWidth} actions={this.props.actions} settings={this.props.settings} />
                    </div>

                    {this.props.isLoading && (
                        <div className="flexcc mt-4 mb-3">
                            <Loader
                                type={"ThreeDots"}
                                color={"#10453d"}
                                height={20}
                                width={50}
                            />
                        </div>
                    )}

                    {!this.props.isLoading && this.state.data?.length == 0 && (
                        <div className="flexcc mt-4 mb-3 w-100">
                            <p className="description-text text-small">{translate('foundNothing').toUpperCase()}</p>
                        </div>
                    )}


                    <div onScroll={(e) => { this.scrollTrigger = 'table'; this.tableScroll(e) }} ref={el => this.table = el} className="w-100 h-100 no-scrollbar test" style={{ overflow: 'auto' }}>
                        <div className="tableBody " style={{ width: this.state.cellWidths['*'] }} >
                            <RowContainerComponent dragstarted={this.dragStarted} dragover={this.dragOver} data={this.state.data} updatedata={RowContainerComponent != 'div' ? this.updateData : null} width={this.state.width}>
                                {Array.isArray(this.state.data) && this.state.data.map((prop, index) => {
                                    return (
                                        <TableRow
                                            ref={el => this[prop.id] = el}
                                            index={index}
                                            data={prop}
                                            page={this.props.page}
                                            headers={this.props.headers}
                                            key={prop?._id ?? prop?.id}
                                            id={prop?._id ?? prop?.id}
                                            viewerUserType={this.props.viewerUserType}
                                            onRecordUpdated={this.props.onRecordUpdated}
                                            widths={this.state.cellWidths}
                                            scrollX={this.state.scrollX}
                                            actions={this.props.actions}
                                            settings={this.props.settings}
                                            openActionsModal={this.openActionsModal}
                                            openRow={this.openRow}
                                        />
                                    )
                                })}
                            </RowContainerComponent>
                        </div>
                    </div>

                    {this.state.cellWidths['*'] > this.state.width && (
                        <div className="tableScroll blur-back" >
                            <div ref={el => this.scrollIndicator = el} className="scrollIndicator" onMouseDown={e => this.scrollMouseDown(e)} style={{ width: (this.state.width / this.state.cellWidths['*']) * 100 + '%', }}></div>
                        </div>
                    )}

                    <Modal ref={el => this.actionsModal = el} maxWidth={300} >
                        <div className="modal-body py-4 px-4" style={{ borderRadius: 12 }}>
                            <p className="text-bold text-uppercase mb-2 text-start" style={{ fontSize: 18, fontWeight: "500" }}>{translate('Choose Action')}</p>
                            <p className="text-bold text-uppercase mb-3 text-start" style={{ fontSize: 14, fontWeight: "400", color: "#789" }}>{translate('Choose one of the steps below to go to the next step')}</p>

                            <div className=''>
                                {this.props.actions && Object.values(this.props.actions)
                                    .filter(prop => {
                                        const hasPermission = !prop.permission
                                            || checkPermission(this.props.variables?.permissionRoot + '.' + prop.permission)
                                        return hasPermission
                                            && isTableActionVisible(
                                                prop,
                                                this.state.selectedRowData,
                                                this.props.viewerUserType
                                            )
                                    })
                                    .map((prop, index) => {
                                        let onlyView = false
                                        if (prop.key == 'edit') {
                                            if (!checkPermission(this.props.variables?.permissionRoot + '.' + 'edit')) {
                                                onlyView = true
                                            }
                                        }
                                        return (
                                            <div key={index} className="mb-2 w-100">
                                                <button onClick={() => this.actionClicked(prop, index)} className="w-100" style={{ background: prop.bg ? prop.bg : 'linear-gradient(135deg, #10453d 0%, #10453d 75%, #146a5d 100%)', borderRadius: 50, padding: '8px 15px', border: 'none', boxShadow: '0 4px 15px rgba(16, 69, 61, 0.25)' }}>
                                                    <p className="text-bold text-uppercase text-normal" style={{ color: prop.color ? prop.color : '#fff', fontWeight: "400", fontSize: 14 }}>{onlyView ? translate('View') : checkTranslation(prop.label)}</p>
                                                </button>
                                            </div>
                                        )
                                })}
                            </div>
                        </div>
                    </Modal>
                </section>
            )
        } else {
            return (<div></div>)
        }
    }
}

export default TableViewer;
